import { Link } from "react-router-dom";
import NavbarVoltar from "../NavbarVoltar";

const Politicas = () => {
  return (
    <div className="bg-white">
      <div className="relative z-50">
        <NavbarVoltar />
      </div>

      <div className="relative isolate px-6 lg:px-8">
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          ></div>
        </div>

        <div className="mx-auto max-w-4xl py-16 text-gray-900">
          <h1 className="mb-8 text-center text-4xl font-bold tracking-tight">
            Política de Privacidade
          </h1>
          <div className="space-y-6 text-lg leading-7">
            <p>
              A <strong>Vintree</strong> valoriza a privacidade de usuários,
              lojistas e visitantes das vitrines. Esta Política explica quais
              dados podemos tratar, para quais finalidades, com quem podem ser
              compartilhados e como os titulares podem exercer seus direitos.
            </p>

            <p className="text-sm text-gray-600">Última atualização: 20/08/2026.</p>

            <h2 className="text-2xl font-semibold">1. Papéis no Tratamento de Dados</h2>
            <p>
              1.1. A Vintree pode atuar como controladora dos dados necessários
              à criação de contas, contratação, cobrança, suporte, segurança e
              operação geral da plataforma.
            </p>
            <p>
              1.2. Quando a plataforma trata dados de visitantes ou clientes da
              vitrine em nome do lojista, como métricas do catálogo, inscrições
              em notificações e registros de campanha, o lojista define as
              finalidades comerciais e é responsável por usar esses dados de
              forma lícita, transparente e compatível com a LGPD.
            </p>

            <h2 className="text-2xl font-semibold">2. Dados que Podemos Coletar</h2>
            <p>Podemos tratar as seguintes categorias de dados:</p>
            <ul className="ml-6 list-disc">
              <li>dados de conta, como nome, e-mail, senha protegida e identificadores internos;</li>
              <li>dados comerciais da loja, como nome da vitrine, links, fotos, produtos, tags e descrições;</li>
              <li>dados de pagamento e assinatura, processados com provedores de pagamento contratados;</li>
              <li>dados técnicos, como endereço IP, dispositivo, navegador, idioma, data, hora, páginas acessadas e logs de segurança;</li>
              <li>dados de uso do catálogo, como visitas, buscas, filtros, cliques, produtos visualizados, origem de acesso e duração aproximada da sessão;</li>
              <li>identificadores de marketing, como cookies, parâmetros de campanha e identificadores de pixel, quando autorizados;</li>
              <li>dados de notificações push, como endpoint do navegador, chaves públicas da inscrição, loja vinculada, status da inscrição, data de consentimento, navegador, dispositivo e registros de envio, falha ou clique.</li>
            </ul>

            <h2 className="text-2xl font-semibold">3. Finalidades do Tratamento</h2>
            <p>Utilizamos dados pessoais para:</p>
            <ul className="ml-6 list-disc">
              <li>criar, autenticar e administrar contas;</li>
              <li>operar vitrines digitais e exibir produtos cadastrados pelo lojista;</li>
              <li>processar assinaturas, pagamentos, suporte e comunicações administrativas;</li>
              <li>gerar métricas de visitas, buscas, cliques e engajamento para o painel do lojista, quando permitido;</li>
              <li>permitir integrações de marketing, pixels e mensuração de campanhas, quando autorizado;</li>
              <li>registrar inscrições e enviar notificações pelo navegador para visitantes que tenham dado opt-in para uma loja específica;</li>
              <li>prevenir fraude, abuso, spam, acessos indevidos e violações dos Termos de Uso;</li>
              <li>cumprir obrigações legais, regulatórias, fiscais e exercer direitos em processos administrativos, judiciais ou arbitrais.</li>
            </ul>

            <h2 className="text-2xl font-semibold">4. Cookies, Pixels e Preferências</h2>
            <p>
              4.1. Utilizamos cookies necessários para autenticação, segurança e
              funcionamento básico da plataforma. Cookies de analytics,
              marketing, pixels e tecnologias semelhantes dependem das
              preferências do visitante ou de outra base legal aplicável.
            </p>
            <p>
              4.2. No catálogo público, o visitante pode aceitar, recusar ou
              ajustar preferências pelo banner de consentimento e pelo ícone de
              privacidade. A recusa de cookies opcionais não impede a navegação
              básica pelo catálogo.
            </p>
            <p>
              4.3. Tags, pixels e códigos de terceiros configurados pelo lojista
              são de responsabilidade do lojista, que deve garantir que possui
              autorização e base legal para utilizá-los.
            </p>

            <h2 className="text-2xl font-semibold">5. Notificações pelo Navegador</h2>
            <p>
              5.1. As notificações push são enviadas somente após autorização do
              visitante para a loja visitada. A inscrição fica vinculada àquela
              loja, ao navegador e ao dispositivo utilizados no opt-in.
            </p>
            <p>
              5.2. O visitante pode cancelar as notificações pelo ícone de
              privacidade do catálogo ou pelas configurações do navegador e do
              sistema operacional. O bloqueio pelo navegador ou pelo sistema
              operacional pode impedir a exibição mesmo quando a Vintree registra
              o envio da mensagem.
            </p>
            <p>
              5.3. O lojista é responsável por utilizar notificações de forma
              moderada, transparente e compatível com a finalidade informada ao
              visitante, evitando spam, conteúdo enganoso ou comunicações
              excessivas.
            </p>

            <h2 className="text-2xl font-semibold">6. Compartilhamento de Dados</h2>
            <p>
              Não vendemos dados pessoais. Podemos compartilhar dados com
              provedores necessários à operação da plataforma, como hospedagem,
              banco de dados, pagamentos, e-mail, análise, segurança,
              atendimento, serviços de push dos navegadores e autoridades
              públicas quando exigido por lei.
            </p>

            <h2 className="text-2xl font-semibold">7. Retenção e Exclusão</h2>
            <p>
              Mantemos dados pelo tempo necessário para cumprir as finalidades
              desta Política, obrigações legais, prevenção de fraude, segurança,
              auditoria e exercício regular de direitos. Inscrições push
              canceladas, inválidas ou expiradas podem ser desativadas ou
              removidas conforme critérios técnicos e legais.
            </p>

            <h2 className="text-2xl font-semibold">8. Segurança</h2>
            <p>
              Adotamos medidas técnicas e organizacionais razoáveis para
              proteger dados pessoais contra acesso não autorizado, perda,
              alteração, divulgação indevida ou destruição. Ainda assim, nenhum
              ambiente digital é totalmente imune a riscos, e o usuário também
              deve proteger suas credenciais e dispositivos.
            </p>

            <h2 className="text-2xl font-semibold">9. Direitos dos Titulares</h2>
            <p>
              Nos termos da LGPD, titulares podem solicitar confirmação de
              tratamento, acesso, correção, anonimização, bloqueio, eliminação,
              portabilidade, informação sobre compartilhamento, revisão de
              decisões automatizadas quando aplicável e revogação de
              consentimento.
            </p>
            <p>
              Solicitações podem ser enviadas para{" "}
              <a
                href="mailto:atendimento@vintree.com.br"
                className="text-fuchsia-700 underline"
              >
                atendimento@vintree.com.br
              </a>
              . Quando a solicitação envolver dados tratados em nome de um
              lojista, poderemos orientar o titular a contatar a loja ou atuar em
              conjunto com ela para atender ao pedido.
            </p>

            <h2 className="text-2xl font-semibold">10. Crianças e Adolescentes</h2>
            <p>
              A plataforma é destinada a lojistas e visitantes em contexto
              comercial. O usuário não deve inserir dados pessoais de crianças ou
              adolescentes na plataforma sem autorização adequada e observância
              da legislação aplicável.
            </p>

            <h2 className="text-2xl font-semibold">11. Alterações nesta Política</h2>
            <p>
              Podemos atualizar esta Política periodicamente. Alterações
              relevantes serão comunicadas por meios razoáveis, e a versão mais
              recente ficará disponível nesta página.
            </p>

            <p>
              Esta Política deve ser lida em conjunto com os{" "}
              <Link
                to="/termos"
                className="text-fuchsia-700 underline hover:text-fuchsia-900"
              >
                Termos de Uso
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Politicas;
